import { render, staticRenderFns } from "./DocumentRuleAddBtn.vue?vue&type=template&id=2788d8c3&scoped=true"
import script from "./DocumentRuleAddBtn.vue?vue&type=script&lang=js"
export * from "./DocumentRuleAddBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2788d8c3",
  null
  
)

export default component.exports